import type { XY } from "../xy";
import { Timing } from "./effect";
import { XYEffect } from "./xyEffect";

export class BigShockBlast extends XYEffect {
	static key = "BigShockBlast";
	constructor(xy: XY) {
		super(xy);
		this.setTiming(Timing.BEFORE_STATE_UPDATE);
	}
}
